module.exports = __webpack_public_path__ + "static/media/2.0ee46c4c.png";